import i18n from 'i18next';

export const SECTIONS_FILTER_FIELDS = [
	{
		name: 'name',
		label: i18n.t('filters:fields.sections_name'),
		type: 'text',
		required: false,
		labelColumn: 3,
		inputColumn: 9
	},
	{
		name: 'label',
		label: i18n.t('filters:fields.label'),
		type: 'text',
		required: false,
		labelColumn: 3,
		inputColumn: 9
	},
	{
		name: 'type',
		label: i18n.t('filters:fields.type'),
		type: 'multi-select',
		required: false,
		mode: '',
		showSearch: true,
		labelColumn: 3,
		inputColumn: 9
	}
];
